var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo2 = function SvgInfo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#info2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.985 0c-6.63 0-12 5.37-12 12s5.37 12 12 12 12-5.37 12-12-5.37-12-12-12Zm-1.53 5.175c.3-.3.66-.45 1.08-.45.42 0 .795.15 1.095.45.3.3.435.66.435 1.095 0 .435-.15.78-.435 1.08-.3.3-.66.45-1.095.45-.435 0-.78-.15-1.08-.45-.3-.3-.45-.66-.45-1.08 0-.42.15-.795.45-1.095Zm4.53 13.035a.901.901 0 0 1-.615.24H9.585a.837.837 0 0 1-.615-.24.77.77 0 0 1-.24-.585.77.77 0 0 1 .24-.585.901.901 0 0 1 .615-.24h1.455v-5.4H9.78a.837.837 0 0 1-.615-.24.77.77 0 0 1-.24-.585.77.77 0 0 1 .24-.585.901.901 0 0 1 .615-.24h2.205c.3 0 .525.09.675.285.15.195.24.45.24.765v5.985h1.455c.24 0 .45.075.615.24.165.15.24.345.24.585s-.075.435-.24.585l.015.015Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgInfo2;